export const getAnalyticsLocalStorage = (companyId = '') => {
    const ajsEntries: { [key: string]: any } = {};
    const prefix = companyId ? `${companyId}_` : 'ajs_';

    for (const key in localStorage) {
        if (Object.prototype.hasOwnProperty.call(localStorage, key)) {
            if (key.indexOf(prefix) === 0) {
                ajsEntries[key] = localStorage[key];
            }
        }
    }

    return ajsEntries;
};

export const prefixAjsLocalStorage = (companyId: string) => {
    const entries = getAnalyticsLocalStorage();

    for (const key in entries) {
        if (Object.prototype.hasOwnProperty.call(entries, key)) {
            localStorage.setItem(`${companyId}_${key}`, entries[key]);
        }
    }
};

export const setAjsLocalStorageByCompanyId = (companyId: string) => {
    const existingLocalStorage = getAnalyticsLocalStorage(companyId);

    for (const key in existingLocalStorage) {
        if (Object.prototype.hasOwnProperty.call(existingLocalStorage, key)) {
            const keyWithoutCompanyId = key.replace(`${companyId}_`, '');
            localStorage.setItem(keyWithoutCompanyId, existingLocalStorage[key]);
        }
    }
};

export const eraseAjsLocalStorage = () => {
    const entries = getAnalyticsLocalStorage();

    for (const key in entries) {
        if (Object.prototype.hasOwnProperty.call(entries, key)) {
            localStorage.removeItem(key);
        }
    }
};
